import { Injectable } from '@angular/core';
import { ClinicalTextTemplate, ClinicalTextTemplateType } from '../../domain/models/clinical-text-template.model';
import { ClinicalTextTemplateDto } from '../dtos/clinical-text-template.dto';

@Injectable({ providedIn: 'root' })
export class ClinicalTextTemplateMapper {
  public toClinicalTextTemplate(dto: ClinicalTextTemplateDto): ClinicalTextTemplate {
    return {
      id: dto.Id,
      title: dto.Title ?? '',
      text: dto.Text ?? '',
      type: this.toType(dto.Type),
    };
  }

  // Falls back to `ClinicalNote` for any value outside the two-member enum, mirroring
  // `ClinicalReportMapper.toDiagnosisCategory`'s "constrained value, defensive fallback" precedent.
  private toType(value: number): ClinicalTextTemplateType {
    return value === ClinicalTextTemplateType.DischargeNote
      ? ClinicalTextTemplateType.DischargeNote
      : ClinicalTextTemplateType.ClinicalNote;
  }
}
